import { addQueryString, urlParse } from '@com/utils/url'
import { mindworksInteractiveAdsUrl } from '@pt/config/host'
// 完整类型定义
interface MindworkURLOptions {
  url: string
  itavideo: number
  orientation: number
  name: string
  language?: string
  env: 0 | 1
  isHttp: boolean
  ptloading?: 0 | 1
}
/**
 *
 *
 * @export
 * @param {MindworkURLOptions} {
 *   url,
 *   itavideo,
 *   orientation,
 *   name,
 *   env = 0,
 *   isHttp = false,
 * }
 * @return {*}  {string}
 */
export function mindworkURL({
  url,
  itavideo,
  orientation,
  name,
  language,
  env = 0,
  isHttp = false,
  ptloading = 1,
}: MindworkURLOptions): string {
  const entryUrl = '/#/mindwork-view'
  const realUrlObj = getRealPreviewUrl(url)
  const materialURL = addQueryString(decodeURIComponent(realUrlObj.url), {
    preview: true,
    itavideo: itavideo,
    vconsole: 0,
    mw_test: env,
    loading: 1,
  })
  const tempUrl = isHttp
    ? mindworksInteractiveAdsUrl.replace('https://', 'http://')
    : mindworksInteractiveAdsUrl
  const extra = {
    ...realUrlObj,
    url: materialURL,
    mw_test: env,
    ptloading, // 是否使用pt loading
  }
  const frameURL = addQueryString(tempUrl, extra)
  const targetURL = addQueryString(entryUrl, {
    url: frameURL,
    orientation: orientation,
    name: name,
    ...(language ? { language: language } : {}),
  })
  return targetURL
}

/**
 * 获取真实的预览 URL
 * @param url - 原始 URL
 * @returns 返回解析后的 URL 参数对象或原始 URL
 */
function getRealPreviewUrl<T extends Record<string, string>>(
  url: string,
): T & { url: string } {
  const adPriviewSign = 'mindworks-interactive-ads'

  // 判断预览地址是否使用壳
  if (url?.includes(adPriviewSign)) {
    const urlQuery: Partial<T> = urlParse(url) as Partial<T>
    if (urlQuery && Object.keys(urlQuery).length > 0 && urlQuery.url) {
      const temp: Partial<T> = {}
      for (const key in urlQuery) {
        if (Object.prototype.hasOwnProperty.call(urlQuery, key)) {
          temp[key] = decodeURIComponent(urlQuery[key] as string) as T[Extract<
            keyof T,
            string
          >]
        }
      }

      // 返回解析后的对象
      return {
        ...(temp as T),
        url: urlQuery.url as string,
      }
    }
  }

  // 默认返回原始 URL
  return {
    url,
  } as T & { url: string }
}
